import { AxiosError, AxiosResponse } from "axios";

/**
 * Generic function to Avoid Unhandled promise rejection error and also handle error granularly.
 *
 * @template T
 * @template U
 * @param {Promise<AxiosResponse>} promise
 * @returns {Promise<{ response?: AxiosResponse<T>; error?: AxiosError<U> }>}
 */
export const handleResponse = async <T, U>(
  promise: Promise<AxiosResponse>
): Promise<{ response?: AxiosResponse<T>; error?: AxiosError<U> }> => {
  try {
    const response: AxiosResponse<T> = await promise;

    return { response };
  } catch (error) {
    return { error };
  }
};
